import { setGlobalConfig } from 'actions/global.config.action'
import { GlobalConfigType } from 'actions/global.config.type'
import { setLoanGlobalStatus, setMenu } from 'actions/loan.action'
import { setVendor } from 'actions/loanDetail.action'
import { LayoutLoading } from 'components/LayoutLoading'
import { setLoanServicingStatus, setLoanStatusConfig } from 'config/loan.status.constants'
import { setAccountTypes } from 'config/user.type.constants'
import { BaseLayout } from 'layouts'
import { setLoanFieldDefaultSection } from 'pages/Admin/AdminTools/Configuration/LoanFieldsProperties/utils'
import { Suspense, useEffect, useState } from 'react'
import TagManager from 'react-gtm-module'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { useDispatch } from 'react-redux'
import { Switch } from 'react-router-dom'
import { BaseRoute, TemporaryRoute } from 'routes'
import { getAdminConfig } from 'services/apis'
import { phoneConvertor } from 'utils'
import { trackApplicationStart } from 'utils/utm'

const queryClient = new QueryClient()

function App() {
  const dispatch = useDispatch()

  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    trackApplicationStart()

    getAdminConfig('appInit').then((data) => {
      const {
        loanStatus,
        menu,
        vendorDetail,
        pagePermissions,
        footerConfig,
        conditionTypeOptions,
        documentCategoryOptions,
        globalSettingV2,
        loanFieldProperties,
        loanSubmissionHierarchy,
        guaranter,
        orderValuationOptions,
        accountTypes,
        loanServicingStatus,
        config,
        parties,
        emailOptions,
        rulesConfig,
        ineligibleParties,
        secondaryMarketing,
      } = data
      let loanStatusObj: any = {}
      Object.keys(loanStatus).map((key) => {
        if (loanStatus[key].use) loanStatusObj[key] = loanStatus[key].new
      })
      setAccountTypes(accountTypes)
      setLoanServicingStatus(loanServicingStatus)
      setLoanStatusConfig(loanStatus)

      dispatch(setLoanGlobalStatus(loanStatusObj))
      dispatch(setMenu(menu))
      dispatch(setVendor(vendorDetail))
      dispatch(setGlobalConfig(GlobalConfigType.LoanStatus, loanStatus))
      dispatch(setGlobalConfig(GlobalConfigType.ConditionTypes, conditionTypeOptions))
      dispatch(setGlobalConfig(GlobalConfigType.DocumentCategory, documentCategoryOptions))
      dispatch(setGlobalConfig(GlobalConfigType.PagePermissions, pagePermissions))
      footerConfig.phone.value = phoneConvertor(footerConfig.phone.value)
      footerConfig.tollFree.value = phoneConvertor(footerConfig.tollFree.value)
      dispatch(setGlobalConfig(GlobalConfigType.Footer, footerConfig))
      dispatch(setGlobalConfig(GlobalConfigType.GlobalSettingV2, globalSettingV2))
      dispatch(setGlobalConfig(GlobalConfigType.LoanFields, setLoanFieldDefaultSection(loanFieldProperties)))
      dispatch(setGlobalConfig(GlobalConfigType.LoanSubmissionHierarchy, loanSubmissionHierarchy))
      dispatch(setGlobalConfig(GlobalConfigType.GUARANTER_CONFIG, guaranter))
      dispatch(setGlobalConfig(GlobalConfigType.ORDER_VALUATION, orderValuationOptions))
      dispatch(setGlobalConfig(GlobalConfigType.ACCOUNT_TYPES, accountTypes))
      dispatch(setGlobalConfig(GlobalConfigType.PARTIES, parties))
      dispatch(setGlobalConfig(GlobalConfigType.EMAIL_OPTIONS, emailOptions))
      dispatch(setGlobalConfig(GlobalConfigType.GTM, config))
      dispatch(setGlobalConfig(GlobalConfigType.RulesConfig, rulesConfig))
      dispatch(setGlobalConfig(GlobalConfigType.IneligibleParties, ineligibleParties))
      dispatch(setGlobalConfig(GlobalConfigType.SecondaryMarketing, secondaryMarketing))

      if (config?.gtmId) {
        TagManager.initialize({
          gtmId: config?.gtmId, // GTM Code
        })
      }

      if (config?.hubspotEmbedId) {
        var hsScript = document.createElement('script')
        hsScript.type = 'text/javascript'
        hsScript.id = 'hs-script-loader'
        hsScript.async = true
        hsScript.defer = true
        hsScript.src = `//js.hs-scripts.com/${config?.hubspotEmbedId}.js`
        document.head.appendChild(hsScript)
      }

      setLoading(false)
    })
  }, [])

  if (isLoading) return <LayoutLoading show />

  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<LayoutLoading show={true} />}>
        <Switch>
          {TemporaryRoute}
          <BaseLayout>
            <BaseRoute />
          </BaseLayout>
        </Switch>
      </Suspense>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default App
